export default __webpack_public_path__ + "static/media/pga-seal.2a26101c.png";